import React, { useEffect, useRef } from 'react'
import { Transformer } from 'react-konva';

const TransformerComponent = ({ selectedShapeName }) => {
	const transformerRef = useRef();

	useEffect(() => {
		const stage = transformerRef.current.getStage();
		const selectedNode = stage.findOne(`.${selectedShapeName}`);

		if (selectedNode) {
			transformerRef.current.nodes([selectedNode]);
			transformerRef.current.getLayer().batchDraw();
		} else {
			transformerRef.current.nodes([]);
			transformerRef.current.getLayer().batchDraw();
		}
	}, [selectedShapeName]);

	return <Transformer ref={transformerRef} />;
};

export default TransformerComponent;